<div class="model-detail">
  <app-header [forceLightBackground]="true"></app-header>
  
  <div class="model-detail--content">
    <app-asset-header
      [config]="headerConfig"
      [isLoggedIn]="isLoggedIn"
      [isBookmarked]="isBookmarked"
      [isLiked]="isLiked"
      [showActions]="true"
      [showShareButton]="true"
      [shareKind]="'Model'"
      [actionsDisabled]="isAssetReadOnly"
      (bookmarkClick)="onBookmarkClick()"
      (likeClick)="onLikeClick()"
    ></app-asset-header>

    <div class="model-detail--container" *ngIf="showDelegateRequestWarning">
      <div class="model-detail--delegate-warning" role="status">
        <svg class="model-detail--delegate-warning-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <line x1="12" y1="9" x2="12" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <line x1="12" y1="17" x2="12.01" y2="17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <span>You cannot request models as a delegate.</span>
      </div>
    </div>
    
    <!-- Main Content: Two Column Layout -->
    <div class="model-detail--main-section" *ngIf="!isLoading">
      <div class="model-detail--container">
        <!-- Warning Message for Pending Publish Status — shown only to the asset creator, not to Org Admins reviewing the asset -->
        <div class="model-detail--pending-warning" *ngIf="showPendingApprovalBanner">
          <div class="model-detail--pending-warning-content">
            <svg class="model-detail--pending-warning-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div class="model-detail--pending-warning-text">
              <strong>Your model is under review.</strong> Will be available for other users to view the model post Approval from {{ pendingApprovalRolesLabel }}.
            </div>
          </div>
        </div>

        <!-- Yellow bar: rejected by platform admin (itemStatus) or org admin (publishStatus) -->
        <div class="model-detail--pending-warning" *ngIf="rejectionBannerMessage">
          <div class="model-detail--pending-warning-content">
            <svg class="model-detail--pending-warning-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div class="model-detail--pending-warning-text">
              {{ rejectionBannerMessage }}
            </div>
          </div>
        </div>

        <!-- Tabs Navigation -->
        <div class="model-detail--tabs-wrapper">
          <div class="model-detail--tabs">
            <button class="model-detail--tab" [class.active]="activeTab === 'model'" (click)="setActiveTab('model')" type="button">Model</button>
            <button class="model-detail--tab" *ngIf="!hasMediaUrl" [class.active]="activeTab === 'details'" (click)="setActiveTab('details')" type="button">Details</button>
            <button class="model-detail--tab" *ngIf="!hasMediaUrl" [class.active]="activeTab === 'visualisation'" (click)="setActiveTab('visualisation')" type="button">Visualisation</button>
            <button class="model-detail--tab" *ngIf="!hasMediaUrl" [class.active]="activeTab === 'sql-playground'" (click)="setActiveTab('sql-playground')" type="button">SQL Playground</button>
            <button class="model-detail--tab" [class.active]="activeTab === 'discussion'" (click)="setActiveTab('discussion')" type="button">Discussion</button>
            <button
              class="model-detail--tab"
              *ngIf="showAdditionalInfoTab"
              [class.active]="activeTab === 'additional-info'"
              (click)="setActiveTab('additional-info')"
              type="button"
            >
              Additional Information
            </button>
          </div>
          <div class="model-detail--tabs-actions" *ngIf="activeTab === 'discussion'">
            <button class="model-detail--new-discussion-btn" type="button" [disabled]="isAssetReadOnly" (click)="createNewDiscussion()">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              New Discussion
            </button>
          </div>
        </div>

        <div class="model-detail--row" [class.full-width]="activeTab !== 'model'">
          <!-- Left Column: Tags, Description and Attributes (col-8) -->
          <div class="model-detail--col-8" [class.full-width]="activeTab !== 'model'">
            <!-- Tab Content: Model -->
            <div class="model-detail--tab-content" *ngIf="activeTab === 'model'">
            <!-- Tags -->
            <div class="model-detail--tags-header" *ngIf="modelTags.length > 0">
              <span 
                *ngFor="let tag of visibleTags" 
                class="model-detail--tag-header"
                [title]="tag"
              >
                {{ tag }}
              </span>
              <span 
                *ngIf="remainingTagsCount > 0"
                class="model-detail--more-link-header"
                (click)="openTagsModal()"
              >
                +{{ remainingTagsCount }} More
              </span>
            </div>
            
            <!-- Description -->
            <p class="model-detail--description" *ngIf="modelDescription">{{ modelDescription }}</p>
            
            <!-- Model Attributes -->
            <div class="model-detail--attributes-section" *ngIf="hasModelDetails">
              <div class="model-detail--attribute-item" *ngIf="modelDetails.uploadedBy">
                <img src="/assets/user-circle-2.svg" alt="User" class="model-detail--attribute-icon" width="20" height="20" />
                <div class="model-detail--attribute-content">
                  <div class="model-detail--attribute-label">Uploaded by:</div>
                  <div class="model-detail--attribute-value">{{ modelDetails.uploadedBy }}</div>
                </div>
              </div>
              
              <div class="model-detail--attribute-item" *ngIf="modelDetails.organisationType">
                <img src="/assets/people (2).svg" alt="People" class="model-detail--attribute-icon" width="20" height="20" />
                <div class="model-detail--attribute-content">
                  <div class="model-detail--attribute-label">Organisation type:</div>
                  <div class="model-detail--attribute-value">{{ modelDetails.organisationType }}</div>
                </div>
              </div>
              
              <div class="model-detail--attribute-item" *ngIf="modelDetails.industry">
                <img src="/assets/building-2 (1).svg" alt="Building" class="model-detail--attribute-icon" width="20" height="20" />
                <div class="model-detail--attribute-content">
                  <div class="model-detail--attribute-label">Industry:</div>
                  <div class="model-detail--attribute-value">{{ modelDetails.industry }}</div>
                </div>
              </div>
              
              <div class="model-detail--attribute-item" *ngIf="modelDetails.license">
                <img src="/assets/gavel.svg" alt="License" class="model-detail--attribute-icon" width="20" height="20" />
                <div class="model-detail--attribute-content">
                  <div class="model-detail--attribute-label">License:</div>
                  <div class="model-detail--attribute-value">{{ modelDetails.license }}</div>
                </div>
              </div>
            </div>

            <!-- Resource Server Details (below License, left column) -->
            <div class="model-detail--resource-servers" *ngIf="resourceServersList.length > 0">
              <div class="model-detail--resource-servers-header">
                <h4 class="model-detail--resource-servers-heading">Resource Server Details</h4>
                <button
                  type="button"
                  class="model-detail--try-out-btn"
                  (click)="openApiExplorer()"
                >
                  API Explorer
                </button>
              </div>

              <div class="model-detail--resource-server-table-wrap" *ngIf="resourceServerDesign === 'table'">
                <table class="model-detail--resource-server-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>URL</th>
                      <th>Query types</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let rs of resourceServersList">
                      <td class="model-detail--rs-table-name">{{ rs.name || '—' }}</td>
                      <td class="model-detail--rs-table-url">{{ rs.url || '—' }}</td>
                      <td class="model-detail--rs-table-types">
                        <span class="model-detail--resource-server-tag" *ngFor="let qt of rs.queryTypes">{{ qt }}</span>
                        <span *ngIf="!rs.queryTypes || !rs.queryTypes.length">—</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            </div>

            <!-- Tab Content: Details, Visualisation, SQL Playground, Discussion - blank placeholder -->
            <!-- Tab Content: Discussion (choice/all API) -->
            <div class="model-detail--tab-content dataset-detail--discussion-loading" *ngIf="activeTab === 'discussion' && modelDiscussionsLoading">
              <p>Loading discussions...</p>
            </div>
            <div class="model-detail--tab-content dataset-detail--discussion-error" *ngIf="activeTab === 'discussion' && !modelDiscussionsLoading && modelDiscussionsError">
              <p>{{ modelDiscussionsError }}</p>
            </div>
            <div class="model-detail--tab-content dataset-detail--discussion-list" *ngIf="activeTab === 'discussion' && !modelDiscussionsLoading && !modelDiscussionsError && modelDiscussions.length > 0">
              <app-asset-discussion-list
                [discussions]="modelDiscussions"
                assetTypeLabel="Model"
                [interactionsDisabled]="isAssetReadOnly"
                (navigate)="navigateToDiscussion($event)"
              ></app-asset-discussion-list>
            </div>
            <div class="model-detail--tab-content dataset-detail--discussion-empty" *ngIf="activeTab === 'discussion' && !modelDiscussionsLoading && !modelDiscussionsError && modelDiscussions.length === 0">
              <p>No discussions yet. Be the first to start a discussion about this model.</p>
            </div>

            <div class="model-detail--tab-placeholder" *ngIf="activeTab === 'details' || activeTab === 'visualisation' || activeTab === 'sql-playground'">
              <p>Content coming soon.</p>
            </div>

            <div class="model-detail--tab-content" *ngIf="activeTab === 'additional-info' && showAdditionalInfoTab">
              <section class="model-detail--ai" *ngIf="feedbackFaqRows.length > 0">
                <h3 class="model-detail--ai-heading">Frequently Asked Questions</h3>
                <div class="model-detail--faq-list">
                  <div
                    class="model-detail--faq-item"
                    *ngFor="let row of feedbackFaqRows; let i = index"
                    [class.model-detail--faq-item--open]="expandedFaqIndex === i"
                  >
                    <button
                      type="button"
                      class="model-detail--faq-trigger"
                      [attr.aria-expanded]="expandedFaqIndex === i"
                      (click)="toggleFaq(i)"
                    >
                      <span class="model-detail--faq-index" aria-hidden="true">{{ i + 1 }}</span>
                      <span class="model-detail--faq-question">{{ row.question }}</span>
                      <span class="model-detail--faq-icon" aria-hidden="true">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                          <path d="M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                          <path
                            class="model-detail--faq-icon-v"
                            d="M12 5V19"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                          />
                        </svg>
                      </span>
                    </button>
                    <div
                      class="model-detail--faq-answer-wrap"
                      [class.model-detail--faq-answer-wrap--open]="expandedFaqIndex === i"
                    >
                      <div class="model-detail--faq-answer-inner">
                        <div class="model-detail--faq-answer">{{ row.answer }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section class="model-detail--ai" *ngIf="feedbackInfoText">
                <h3 class="model-detail--ai-heading">Information</h3>
                <p class="model-detail--ai-copy">{{ feedbackInfoText }}</p>
              </section>
            </div>
          </div>

          <!-- Right Column: Model Details and Actions (col-3) -->
          <div class="model-detail--col-3" *ngIf="activeTab === 'model'">
            <!-- Activity Overview Card -->
            <div class="model-detail--activity-overview">
              <div class="activity-overview--header">
                <h3 class="model-detail--section-title">Activity Overview</h3>
              </div>
              <div class="activity-overview--metrics">
                <!-- Like -->
                <div class="activity-overview--metric" [class.active]="isLiked">
                  <svg class="activity-overview--metric-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                      [attr.fill]="isLiked ? '#059669' : 'none'"
                      stroke="#059669"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span class="activity-overview--metric-value">{{ activityMetrics.likes | number }}</span>
                </div>
                <!-- View -->
                <div class="activity-overview--metric">
                  <svg class="activity-overview--metric-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                  </svg>
                  <span class="activity-overview--metric-value">{{ activityMetrics.views | number }}</span>
                </div>
                <!-- Download -->
                <div class="activity-overview--metric">
                  <svg class="activity-overview--metric-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 15V3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span class="activity-overview--metric-value">{{ activityMetrics.downloads | number }}</span>
                </div>
              </div>
            </div>

            <div class="model-detail--right-section">
              <div class="model-detail--right-header">
                <h3 class="model-detail--section-title">Model details</h3>
                <ng-container *ngIf="!isAssetReadOnly">
                <button
                  *ngIf="shouldShowRequestAccessButton"
                  type="button"
                  class="model-detail--request-access-btn model-detail--request-access-btn--header"
                  [disabled]="isRequestAccessButtonDisabled"
                  (click)="onRequestAccess()"
                >
                  {{ requestAccessButtonText }}
                  <svg *ngIf="!isRequestAccessButtonDisabled" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <polyline points="9 18 15 12 9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <button
                  *ngIf="shouldShowDownloadButton || shouldShowDownloadButtonForRestricted"
                  type="button"
                  class="model-detail--header-btn"
                  (click)="onDownload()"
                >
                  Download
                  <svg class="model-detail--header-btn-icon model-detail--header-btn-icon--stroke" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <polyline points="7 10 12 15 17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </button>
                <button 
                  class="model-detail--header-btn"
                  (click)="onGithubRepoClick()" 
                  *ngIf="shouldShowMediaUrlButton"
                >
                  <ng-container *ngIf="isMediaUrlGithub">
                    <img src="/assets/github.svg" alt="GitHub" class="model-detail--header-btn-icon" width="14" height="14" />
                    <span>GitHub Repo</span>
                  </ng-container>
                  <ng-container *ngIf="!isMediaUrlGithub">
                    <svg class="model-detail--header-btn-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <polyline points="15 3 21 3 21 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <line x1="10" y1="14" x2="21" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>Redirect Link</span>
                  </ng-container>
                </button>
                </ng-container>
              </div>
              
              <!-- Model Details List -->
              <div class="model-detail--details-list">
                <!-- Permission - aligned with dataset design -->
                <div class="model-detail--detail-item model-detail--permission-item" *ngIf="modelCardDetails.badge">
                  <svg class="model-detail--detail-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="model-detail--detail-content">
                    <div class="model-detail--detail-label">Permission:</div>
                    <div class="model-detail--detail-value">
                      <span class="model-detail--permission-badge">
                        <svg class="model-detail--permission-badge-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M12 2v20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <circle cx="12" cy="12" r="2" fill="currentColor"/>
                        </svg>
                        <span>{{ modelCardDetails.badge }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                
                <div class="model-detail--detail-item" *ngIf="modelDetails.uploadedBy">
                  <img src="/assets/user-circle-2.svg" alt="Uploaded by" class="model-detail--detail-icon" width="20" height="20" />
                  <div class="model-detail--detail-content">
                    <div class="model-detail--detail-label">Uploaded by:</div>
                    <div class="model-detail--detail-value">{{ modelDetails.uploadedBy }}</div>
                  </div>
                </div>
                
                <div class="model-detail--detail-item" *ngIf="modelCardDetails.modelType">
                  <img src="/assets/cpu.svg" alt="Model Type" class="model-detail--detail-icon" width="20" height="20" />
                  <div class="model-detail--detail-content">
                    <div class="model-detail--detail-label">Model Type:</div>
                    <div class="model-detail--detail-value">{{ modelCardDetails.modelType }}</div>
                  </div>
                </div>
                
                <div class="model-detail--detail-item" *ngIf="modelCardDetails.programmingLanguage">
                  <img src="/assets/code-2.svg" alt="Programming Language" class="model-detail--detail-icon" width="20" height="20" />
                  <div class="model-detail--detail-content">
                    <div class="model-detail--detail-label">Programming Language:</div>
                    <div class="model-detail--detail-value">{{ modelCardDetails.programmingLanguage }}</div>
                  </div>
                </div>

                <div class="model-detail--detail-item" *ngIf="modelCardDetails.fileFormat">
                  <svg class="model-detail--detail-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M13 2V9H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="model-detail--detail-content">
                    <div class="model-detail--detail-label">File format:</div>
                    <div class="model-detail--detail-value">{{ modelCardDetails.fileFormat }}</div>
                  </div>
                </div>
                
                <div class="model-detail--detail-item" *ngIf="modelCardDetails.createdAt">
                  <img src="/assets/history.svg" alt="Last Updated" class="model-detail--detail-icon" width="20" height="20" />
                  <div class="model-detail--detail-content">
                    <div class="model-detail--detail-label">Last Updated:</div>
                    <div class="model-detail--detail-value">
                      {{ getCreatedAtDate(modelCardDetails.createdAt) }}
                      <span class="model-detail--detail-time" *ngIf="getCreatedAtTime(modelCardDetails.createdAt)">
                        {{ getCreatedAtTime(modelCardDetails.createdAt) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section class="dataset-detail--user-ratings" *ngIf="activeTab === 'model' && showUserRatingsSection" aria-labelledby="model-user-ratings-heading">
          <h2 id="model-user-ratings-heading" class="dataset-detail--user-ratings-title">User Ratings</h2>
          <ng-container *ngIf="hasUserRatings; else userRatingsEmptyState">
            <div class="dataset-detail--user-ratings-toolbar">
              <div class="dataset-detail--user-ratings-score">
                <span class="dataset-detail--user-ratings-stars" aria-hidden="true">
                  <span class="dataset-detail--rating-star" *ngFor="let star of [1, 2, 3, 4, 5]">
                    <img src="icons/dataset-ratings/star-outline.svg" alt="" width="24" height="24" />
                    <span class="dataset-detail--rating-star-fill" [style.width.%]="ratingStarFillPercent(star)">
                      <img src="icons/dataset-ratings/star-filled.svg" alt="" width="24" height="24" />
                    </span>
                  </span>
                </span>
                <p class="dataset-detail--user-ratings-score-text">
                  <strong>{{ userRatingsAverageDisplay }}</strong>
                  <span>({{ userRatingsCount }} {{ userRatingsCount === 1 ? 'user rating' : 'users rating' }})</span>
                </p>
              </div>
              <div class="dataset-detail--user-ratings-actions">
                <div class="dataset-detail--user-ratings-filter">
                  <button type="button" class="dataset-detail--user-ratings-text-btn" (click)="toggleUserRatingsFilterMenu()" [attr.aria-expanded]="showUserRatingsFilterMenu">
                    <img src="filters/filter.svg" alt="" width="20" height="20" />
                    <span>{{ userRatingsFilterLabel }}</span>
                    <svg class="dataset-detail--user-ratings-chevron" [class.open]="showUserRatingsFilterMenu" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                  <ul class="dataset-detail--user-ratings-filter-menu" *ngIf="showUserRatingsFilterMenu">
                    <li>
                      <button type="button" [class.active]="userRatingsFilter == null" (click)="setUserRatingsFilter(null)">All ratings</button>
                    </li>
                    <li *ngFor="let star of [5, 4, 3, 2, 1]">
                      <button type="button" [class.active]="userRatingsFilter === star" (click)="setUserRatingsFilter(star)">
                        {{ star }} {{ star === 1 ? 'star' : 'stars' }}
                      </button>
                    </li>
                  </ul>
                </div>
                <button type="button" class="dataset-detail--user-ratings-text-btn" (click)="toggleUserRatingsSort()">
                  <span>Sort: <strong>{{ userRatingsSort === 'new' ? 'New to Old' : 'Old to New' }}</strong></span>
                  <span aria-hidden="true">⇅</span>
                </button>
                <button
                  *ngIf="canPerformUserFeedback && !showAccessRequiredRatingState && (hasOwnRating || hasOwnPendingRating || !blockNewRating)"
                  type="button"
                  class="dataset-detail--user-ratings-text-btn dataset-detail--user-ratings-text-btn-primary"
                  (click)="onGiveRating()"
                >
                  <svg class="dataset-detail--user-ratings-write-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                    <path d="M18.3335 14.1667C18.3335 14.6087 18.1579 15.0326 17.8454 15.3452C17.5328 15.6577 17.1089 15.8333 16.6669 15.8333H5.6902C5.24821 15.8334 4.82436 16.0091 4.51187 16.3217L2.67687 18.1567C2.59412 18.2394 2.48871 18.2957 2.37394 18.3186C2.25918 18.3414 2.14023 18.3297 2.03213 18.2849C1.92402 18.2401 1.83162 18.1643 1.76661 18.067C1.70159 17.9697 1.66689 17.8553 1.66687 17.7383V4.16667C1.66687 3.72464 1.84246 3.30072 2.15503 2.98816C2.46759 2.67559 2.89151 2.5 3.33354 2.5H16.6669C17.1089 2.5 17.5328 2.67559 17.8454 2.98816C18.1579 3.30072 18.3335 3.72464 18.3335 4.16667V14.1667Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M10 6.66672V11.6667" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M7.5 9.16672H12.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span>{{ giveRatingCtaLabel }}</span>
                </button>
              </div>
            </div>
            <div class="dataset-detail--user-ratings-grid" *ngIf="visibleUserReviews.length; else userRatingsFilterEmpty">
              <article class="dataset-detail--review-card" *ngFor="let review of visibleUserReviews">
                <div class="dataset-detail--review-card-person">
                  <span class="dataset-detail--review-card-avatar">{{ review.initials }}</span>
                  <div class="dataset-detail--review-card-meta">
                    <p class="dataset-detail--review-card-name">{{ review.name }}</p>
                    <p class="dataset-detail--review-card-org" *ngIf="review.organisation">{{ review.organisation }}</p>
                  </div>
                </div>
                <div class="dataset-detail--review-card-rating">
                  <span class="dataset-detail--review-card-stars" [attr.aria-label]="'Rating ' + review.ratingValue + ' out of 5'">
                    <img
                      *ngFor="let star of [1, 2, 3, 4, 5]"
                      [src]="userRatingsStarFilled(star, review.ratingValue) ? 'icons/dataset-ratings/star-filled.svg' : 'icons/dataset-ratings/star-outline.svg'"
                      alt=""
                      width="20"
                      height="20"
                    />
                  </span>
                  <time class="dataset-detail--review-card-date" *ngIf="review.createdAt">{{ review.createdAt }}</time>
                </div>
                <p class="dataset-detail--review-card-comment" *ngIf="review.comment">{{ review.comment }}</p>
              </article>
            </div>
            <ng-template #userRatingsFilterEmpty>
              <p class="dataset-detail--user-ratings-filter-empty">No reviews match these filters.</p>
            </ng-template>
            <div class="dataset-detail--user-ratings-pager" *ngIf="userRatingsPageCount > 1">
              <button type="button" class="dataset-detail--user-ratings-pager-btn" [disabled]="userRatingsPage === 0" (click)="goToUserRatingsPage(userRatingsPage - 1)" aria-label="Previous reviews">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
              <div class="dataset-detail--user-ratings-dots">
                <button *ngFor="let page of userRatingsPageIndexes" type="button" class="dataset-detail--user-ratings-dot" [class.active]="page === userRatingsPage" (click)="goToUserRatingsPage(page)" [attr.aria-label]="'Reviews page ' + (page + 1)"></button>
              </div>
              <button type="button" class="dataset-detail--user-ratings-pager-btn" [disabled]="userRatingsPage >= userRatingsPageCount - 1" (click)="goToUserRatingsPage(userRatingsPage + 1)" aria-label="Next reviews">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
            </div>
          </ng-container>
          <ng-template #userRatingsEmptyState>
            <div class="dataset-detail--user-ratings-card">
              <span class="dataset-detail--user-ratings-icon" aria-hidden="true">
                <img *ngIf="showAccessRequiredRatingState" src="icons/dataset-ratings/rating-locked.svg" alt="" width="30" height="30" />
                <img *ngIf="!showAccessRequiredRatingState" src="icons/dataset-ratings/rating-empty.svg" alt="" width="30" height="30" />
              </span>
              <ng-container *ngIf="showAccessRequiredRatingState; else ratingEligibleEmpty">
                <h3 class="dataset-detail--user-ratings-heading">Access required to provide rating</h3>
                <p class="dataset-detail--user-ratings-copy">Request access to use this model and share your rating based on your experience.</p>
              </ng-container>
              <ng-template #ratingEligibleEmpty>
                <ng-container *ngIf="hasOwnPendingRating; else firstToRate">
                  <h3 class="dataset-detail--user-ratings-heading">You have submitted your Rating</h3>
                  <p class="dataset-detail--user-ratings-copy">Admin review is in progress</p>
                  <button *ngIf="canPerformUserFeedback" type="button" class="dataset-detail--user-ratings-cta" (click)="onGiveRating()">
                    <img src="icons/dataset-ratings/rating-write.svg" alt="" width="20" height="20" />
                    <span>Edit Your Rating</span>
                  </button>
                </ng-container>
                <ng-template #firstToRate>
                  <h3 class="dataset-detail--user-ratings-heading">{{ canPerformUserFeedback ? 'Be the first to rate this model' : 'Ratings will appear here once users share feedback.' }}</h3>
                  <p class="dataset-detail--user-ratings-copy" *ngIf="canPerformUserFeedback">Share your experience to help others decide.</p>
                  <button *ngIf="canPerformUserFeedback && !blockNewRating" type="button" class="dataset-detail--user-ratings-cta" (click)="onGiveRating()">
                    <img src="icons/dataset-ratings/rating-write.svg" alt="" width="20" height="20" />
                    <span>{{ giveRatingCtaLabel }}</span>
                  </button>
                </ng-template>
              </ng-template>
            </div>
          </ng-template>
        </section>
      </div>
    </div>

    <!-- Loading State -->
    <div class="model-detail--loading" *ngIf="isLoading">
      <div class="model-detail--container">
        <p>Loading model details...</p>
      </div>
    </div>

    <!-- Similar Models Section -->
    <div class="model-detail--similar-section" *ngIf="!isLoading">
      <div class="model-detail--container">
        <app-similar-datasets 
          [models]="similarModels"
          [title]="'Related Models'"
          [assetType]="'model'"
          [itemsToShow]="3"
          [showDots]="true"
          [showArrows]="true"
          [gap]="24"
        ></app-similar-datasets>
      </div>
    </div>
  </div>

  <app-footer></app-footer>

  <!-- Tags Modal -->
  <app-modal
    [(visible)]="showTagsModal"
    header="All Tags"
    [width]="'600px'"
    [showFooter]="false"
    (visibleChange)="showTagsModal = $event"
  >
    <div class="tags-modal-content">
      <div class="tags-modal--tags">
        <span
          *ngFor="let tag of allTags"
          class="model-detail--tag"
        >
          {{ tag }}
        </span>
      </div>
    </div>
  </app-modal>

  <!-- Login Modal -->
  <app-login-modal *ngIf="showLoginModal" (visibleChange)="showLoginModal = false"></app-login-modal>

  <app-modal
    [(visible)]="showGiveRatingModal"
    [header]="giveRatingModalHeader"
    [width]="'512px'"
    styleClass="custom-modal give-rating-dialog"
    maskStyleClass="give-rating-mask"
    appendTo="body"
    [showFooter]="false"
    (visibleChange)="onGiveRatingModalVisibleChange($event)"
  >
    <div class="give-rating">
      <p class="give-rating--subtitle">
        {{ isViewingOwnRating ? 'This is the rating you submitted for this model.' : isEditingOwnRating ? 'Update how this model performed for your use case.' : 'Share how this model performed for your use case.' }}
      </p>
      <div class="give-rating--field">
        <label class="give-rating--label" id="model-give-rating-stars-label">
          Rating <span class="give-rating--required" *ngIf="!isViewingOwnRating">*</span>
        </label>
        <div class="give-rating--stars" role="radiogroup" aria-labelledby="model-give-rating-stars-label" (mouseleave)="hoveredRating = 0">
          <button
            *ngFor="let star of [1, 2, 3, 4, 5]"
            type="button"
            class="give-rating--star"
            role="radio"
            [attr.aria-checked]="selectedRating === star"
            [attr.aria-label]="star + ' star'"
            [disabled]="isViewingOwnRating"
            (mouseenter)="hoveredRating = isViewingOwnRating ? hoveredRating : star"
            (click)="selectRating(star)"
          >
            <img [src]="displayedRating >= star ? 'icons/dataset-ratings/star-filled.svg' : 'icons/dataset-ratings/star-outline.svg'" alt="" width="40" height="40" />
          </button>
        </div>
        <p class="give-rating--error" *ngIf="showRatingRequiredError">Please select a rating</p>
      </div>
      <div class="give-rating--field">
        <label class="give-rating--label" for="model-give-rating-feedback">Feedback</label>
        <div class="give-rating--textarea-wrap">
          <textarea id="model-give-rating-feedback" class="give-rating--textarea" rows="5" maxlength="200" placeholder="Enter your feedback..." [(ngModel)]="ratingFeedback" [readOnly]="isViewingOwnRating"></textarea>
          <span class="give-rating--counter">{{ ratingFeedbackLength }}/{{ ratingFeedbackMax }}</span>
        </div>
      </div>
      <div class="give-rating--actions">
        <button type="button" class="give-rating--cancel" (click)="closeGiveRatingModal()">{{ isViewingOwnRating ? 'Close' : 'Cancel' }}</button>
        <button *ngIf="!isViewingOwnRating" type="button" class="give-rating--submit" [disabled]="isSubmittingRating || (isEditingOwnRating && !canSaveRatingEdit)" (click)="submitGiveRating()">{{ isEditingOwnRating ? 'Save' : 'Submit Rating' }}</button>
      </div>
    </div>
  </app-modal>

  <!-- Request Access Modal -->
  <app-request-access
    [visible]="showRequestAccessModal"
    [userHasOrganisation]="userHasOrganisation"
    [organisationName]="requestAccessOrganisationName"
    [closeOnSubmit]="false"
    (visibleChange)="showRequestAccessModal = $event"
    (requestAccessSubmit)="onRequestAccessSubmit($event)"
  ></app-request-access>

  <lib-api-explorer
    *ngIf="apiExplorerContext"
    [visible]="showApiExplorer"
    [context]="apiExplorerContext"
    (visibleChange)="onApiExplorerVisibleChange($event)"
    (loginRequired)="onApiExplorerLoginRequired()"
  />
</div>
